import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { WidgetParent } from "../../class/widget-parent";
import { ComponentAdapterFactory } from "../../class/adapters/component-adapter-factory";
import { ComponentAdaperBlind } from "../../class/adapters/component-adapter-blind";
import { SmartPaletteGeneral } from "../../class/smart-palette";
import { IconHelper } from "../../class/icon-helper";
import { IonButton, IonIcon, IonLabel } from "@ionic/angular";
import { DraggableSliderComponent } from "../draggable-slider/draggable-slider.component";
import { SmartComponentSpinnerComponent } from "../smart-component-spinner/smart-component-spinner.component";
import { ErrorLoadingWidgetComponent } from "../error-loading-widget/error-loading-widget.component";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "app-widget-blind",
    templateUrl: "./widget-blind.component.html",
    styleUrls: ["./widget-blind.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonButton, IonIcon, IonLabel, DraggableSliderComponent, SmartComponentSpinnerComponent, ErrorLoadingWidgetComponent, TranslatePipe]
})
export class WidgetBlindComponent extends WidgetParent<ComponentAdaperBlind> {
  public progressValueHeight: number = 0;
  public allowHeightChange: boolean = false;
  public slatPositionValue: number = 0;
  public isExpanded: boolean = false;

  public iconHelper = IconHelper;

  /**
   * Callback event for slide height changes
   *
   * @param progressValue Value received from slider component
   */
  public onSlideHeight(value: number): void {
    if (this.componentAdapter.HeightCommand !== null) {
      this.sendHeightCommand(value);
    }
  }

  /**
    * Send value to slat position command when change value on slider
    * @param value Value received from slider component
    */
  public onSlideSlatPosition(value: number): void {
    if (this.componentAdapter.SlatPositionCommand !== null) {
      this.sendSlatPositionCommand(value);
    }
  }

  /**
   * Handle click of open blind
   */
  public openBlind(): void {
    if (this.componentAdapter.OpenCommand) {
      const instanceGUID: string =
        this.componentAdapter.OpenCommand.instanceGUID;
      const address: string = this.componentAdapter.OpenCommand.address;

      // Send command to open blind
      this.sendAddressCommand(instanceGUID, address, "0");
    }
  }

  /**
   * Handle click of close blind
   */
  public closeBlind(): void {
    if (this.componentAdapter.CloseCommand) {
      const instanceGUID: string =
        this.componentAdapter.CloseCommand.instanceGUID;
      const address: string = this.componentAdapter.CloseCommand.address;

      // Send command to close blind
      this.sendAddressCommand(instanceGUID, address, "1");
    }
  }

  /**
   * Handle click of stop blind
   */
  public stopBlind(): void {
    if (this.componentAdapter.StopCommand) {
      const instanceGUID: string =
        this.componentAdapter.StopCommand.instanceGUID;
      const address: string = this.componentAdapter.StopCommand.address;

      // Send command to stop blind
      this.sendAddressCommand(instanceGUID, address, "1");
    }
  }

  /**
   * Check if there are any component used in the expanded part of the component. 
   * If there aren't any hide the arrow to expand the component.
   * @returns boolean value
   */
  public checkIfComponentIsExpandable(): boolean {
    if ((this.componentAdapter.HeightCommand || this.componentAdapter.HeightState || this.componentAdapter.SlatPositionCommand || this.componentAdapter.SlatPositionState) && !this.isSupervision && !this.isSupervisionModalOpen) {
      return true;
    }
    return false;
  }

  /**
   * Handle click for opening and closing widget
   */
  public onClickOpenCloseWidget(): void {
    this.isExpanded = !this.isExpanded;
  }

  protected setWidgetSmartPalette(): SmartPaletteGeneral {
    let widgetSmaertPalette = new SmartPaletteGeneral();

    return widgetSmaertPalette;
  }

  protected onComponentLoad(): void { }

  protected onComponentDestroy(): void { }

  protected onSmartComponentErrorLoading(): void { }

  protected onSmartComponentSuccessLoaded(): void | boolean {
    const factory = new ComponentAdapterFactory();
    this.componentAdapter = factory.createComponentAdapter(
      this._listSmartComponentSkills,
      ComponentAdaperBlind
    );

    this.titleWidget = this.componentAdapter.Name;

    //If component title is empty show error loading component
    if (!this.titleWidget) {
      return this._errorLoading = true;
    }

    this.isExpanded = this._isExpanded;

    this.allowHeightChange = this.componentAdapter.HeightCommand !== null;
  }

  protected onAddressValueChange(
    instanceGUID: string,
    address: string,
    value: string
  ): void {
    if (this.componentAdapter.HeightState) {
      this.tryToUpdateStateHeight(instanceGUID, address, value);
    }

    if (this.componentAdapter.SlatPositionState) {
      this.tryToUpdateSlatPositionState(instanceGUID, address, value);
    }
  }

  /**
   * Try to update height state based on the value of the address
   *
   * @param instanceGUID Instance GUID received for value
   * @param address Address received
   * @param value Value received
   */
  private tryToUpdateStateHeight(
    instanceGUID: string,
    address: string,
    value: string
  ): void {
    if (
      instanceGUID === this.componentAdapter.HeightState.instanceGUID &&
      address === this.componentAdapter.HeightState.address
    ) {
      this.progressValueHeight = parseInt(value);
    }
  }

  /**
   * Send command value to change the height of the blind
   *
   * @param value Value to set blind height
   */
  private sendHeightCommand(value: number) {
    const instanceGUID: string =
      this.componentAdapter.HeightCommand.instanceGUID;
    const address: string = this.componentAdapter.HeightCommand.address;

    this.sendAddressCommand(instanceGUID, address, value.toString());
  }

  /**
   * Try to update slat position state based on the value of the address
   *
   * @param instanceGUID Instance GUID received for value
   * @param address Address received
   * @param value Value received
   */
  private tryToUpdateSlatPositionState(instanceGUID: string, address: string, value: string): void {
    if (instanceGUID === this.componentAdapter.SlatPositionState.instanceGUID && address === this.componentAdapter.SlatPositionState.address) {
      this.slatPositionValue = parseInt(value);
    }
  }

  /**
   * Send command value to change the slat position of the blind
   * @param value value to set for slat position
   */
  private sendSlatPositionCommand(value: number) {
    const instanceGUID: string = this.componentAdapter.SlatPositionCommand.instanceGUID;
    const address: string = this.componentAdapter.SlatPositionCommand.address;

    this.sendAddressCommand(instanceGUID, address, value.toString());
  }
}
